import React, { lazy, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { fetchMe } from "../app/auth/authThunk";
import { LoginKey, ProfileKey } from "../utils/contVarible";

import PrivateRoute from "../components/PrivateRoute";
import ScrollToTop from "../components/ScrollToTop";
import HistoryPage from "./login/profile/HistoryPage";
// import Plumber from "../Allservices/Plumber";
// import Electrician from "../Allservices/Electrician";

const MainLayout = lazy(() => import("../layout/MainLayout"));
const HomeScreen = lazy(() => import("../screen/HomeScreen/Home"));
const SubServicesScreen = lazy(
  () => import("../screen/SubServiceScreen/SubServices"),
);
const CartPage = lazy(() => import("./cart/CartPage"));
const CheckoutPage = lazy(() => import("./checkout/CheckoutPage"));

const AppRoute = () => {
  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);
  const dispatch = useDispatch();

  const [loginOpen, setLoginOpen] = useState(false);
  const [loginMode, setLoginMode] = useState(LoginKey);
  const [openProfileAfterLogin, setOpenProfileAfterLogin] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(fetchMe());
    }
  }, [dispatch]);

  const openLogin = () => {
    setLoginMode(LoginKey);
    setLoginOpen(true);
  };

  const openProfile = () => {
    if (isAuthenticated) {
      setLoginMode(ProfileKey);
      setLoginOpen(true);
    } else {
      setLoginMode(LoginKey);
      setLoginOpen(true);
      setOpenProfileAfterLogin(true);
    }
  };

  const handleLoginSuccess = () => {
    if (openProfileAfterLogin) {
      setLoginMode(ProfileKey);
      setOpenProfileAfterLogin(false);
      return;
    }
    setLoginOpen(false);
  };

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          element={
            <MainLayout
              openLogin={openLogin}
              openProfile={openProfile}
              loginOpen={loginOpen}
              loginMode={loginMode}
              handleLoginSuccess={handleLoginSuccess}
              setLoginOpen={setLoginOpen}
              setOpenProfileAfterLogin={setOpenProfileAfterLogin}
            />
          }
        >
          {/* PAGE ROUTES */}
          <Route path="/" element={<HomeScreen />} />
          <Route path="/services/:category" element={<SubServicesScreen />} />

          <Route element={<PrivateRoute />}>
            {/*  -------------------- Whatever needs login goes below -------------------- */}
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/history" element={<HistoryPage />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default React.memo(AppRoute);
